<template>
	<div>
		<!-- px-4 keeps the longer per-reason headings clear of the Modal's absolute close X on phones. -->
		<h2 class="px-4 text-center text-[20px] leading-[28px] font-semibold text-balance text-gray-900">
			{{ title }}
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			{{ description }}
		</p>

		<textarea
			v-model="feedback"
			:placeholder="placeholder"
			class="
				mt-4 h-[100px] w-full rounded-md border border-gray-300 px-3 py-2
				text-[14px] leading-[20px] text-gray-900 placeholder:text-gray-400
			"
		/>

		<button
			type="button"
			:disabled="isSubmitting"
			class="
				mx-auto mt-6 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-won-green px-3 text-[16px] leading-[20px] font-medium text-white
				hover:bg-won-green-dark disabled:cursor-default
			"
			@click="emit('submit', feedback.trim())"
		>
			<template v-if="isSubmitting">
				<LoadingIcon margin="" />
			</template>
			<template v-else>
				Continue
			</template>
		</button>
	</div>
</template>

<script setup>
import { ref } from 'vue';

import LoadingIcon from '../../../../icons/loading-spinner.vue';

defineProps({
	title: {
		type: String,
		required: true,
	},
	description: {
		type: String,
		required: true,
	},
	placeholder: {
		type: String,
		required: true,
	},
	isSubmitting: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['submit']);

// The field is optional everywhere it is used, so Continue always emits — an untouched
// textarea sends an empty string rather than blocking the branch.
const feedback = ref('');
</script>
